module.exports = __webpack_public_path__ + "static/img/6810_phase_function_Paper_PointsHejduk_Prediction.dfe40f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6810_phase_function_Paper_PointsHejduk_Prediction.png
// module id = VJw9
// module chunks = 0